module.exports = __webpack_public_path__ + "static/media/diritto-tributario.1c576ba4.jpg";